import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ROUTES } from './Constants/index';
import Home from '../src/Views/Home/Home';
import Donate from '../src/Views/GetInvolved/Donate';
import GetInvolved from '../src/Views/GetInvolved/GetInvolved';
import Thanks from '../src/Views/GetInvolved/Thanks';
import AboutUs from '../src/Views/Home/AboutUs';
import FounderMessage from '../src/Views/Home/FounderMessage';
import OurTeam from '../src/Views/Home/OurTeam';
import FreeGrocery from '../src/Views/Programs/FreeGrocery';
import ApnaRozgar from '../src/Views/Programs/ApnaRozgar';
import BasicSchools from '../src/Views/Programs/BasicSchools';
import MedicalSupport from '../src/Views/Programs/MedicalSupport';
import WaterHandPumps from '../src/Views/Programs/WaterHandPumps';
import FloodVictims from '../src/Views/Programs/FloodVictims';
import Videos from '../src/Views/Gallery/Videos';
import QurbaniThanks from './Views/GetInvolved/QurbaniThanks';
import DonateToQurbaniUdhiyaSadaqahObligations from './Views/Programs/DonateToQurbaniUdhiyaSadaqahObligations';
import HelpingAnOrphan from './Views/Blogs/HelpingAnOrphan';

import './App.css';
import FloodVictimsPakistan from './Views/Programs/FloodVictimsPakistan';
import Projects202224 from './Views/Programs/Projects202224';
import FinancialMonthlySupport from './Views/Projects/FinancialMonthlySupport';
import MonthlyRationSupport from './Views/Projects/MonthlyRationSupport';
import SmallBusinessProgram from './Views/Projects/SmallBusinessProgram';
import TechnicalCenterForEmpoweringWomen from './Views/Projects/TechnicalCenterForEmpoweringWomen';
import EducationProgram from './Views/Projects/EducationProgram';
import MedicalProgram from './Views/Projects/MedicalProgram';
import CleanWaterProjects from './Views/Projects/CleanWaterProjects';

import WomensVocationalTraining from './Views/Programs/WomensVocationalTraining';
import HeatstrokeReliefCamps from './Views/Programs/HeatstrokeReliefCamps';
import OrphanMarriageAssistance from './Views/Programs/OrphanMarriageAssistance';

function App() {
  return (
    <Router>
      <Switch>
        {' '}
        <Route exact path={ROUTES.HOME} component={Home} />
        <Route exact path={ROUTES.DONATE} component={Donate} />
        <Route exact path={ROUTES.ABOUT} component={AboutUs} />
        <Route exact path={ROUTES.FOUNDERMESSAGE} component={FounderMessage} />
        <Route exact path={ROUTES.OURTEAM} component={OurTeam} />
        <Route exact path={ROUTES.FREEGROCERY} component={FreeGrocery} />
        <Route exact path={ROUTES.APNAROZGAR} component={ApnaRozgar} />
        <Route exact path={ROUTES.THANKS} component={Thanks} />
        <Route exact path={ROUTES.QTHANKS} component={QurbaniThanks} />
        <Route exact path={ROUTES.SCHOOLS} component={BasicSchools} />
        <Route exact path={ROUTES.MEDICALSUPPORT} component={MedicalSupport} />
        <Route exact path={ROUTES.WATERHANDPUMPS} component={WaterHandPumps} />
        <Route exact path={ROUTES.VIDEOS} component={Videos} />
        <Route exact path={ROUTES.GETINVOLVED} component={GetInvolved} />
        <Route
          exact
          path={ROUTES.QURBANIUDHIYASADAQAHOBLIGATIONS}
          component={DonateToQurbaniUdhiyaSadaqahObligations}
        />
        <Route exact path={ROUTES.FLOODVICTIMSP} component={FloodVictims} />
        <Route
          exact
          path={ROUTES.FLOODVICTIMSPAKISTAN}
          component={FloodVictimsPakistan}
        />
        <Route
          exact
          path={ROUTES.FLOODVICTIMSPAKI}
          component={FloodVictimsPakistan}
        />
        <Route
          exact
          path={ROUTES.HELPINGANORPHAN}
          component={HelpingAnOrphan}
        />
        <Route
          exact
          path={ROUTES.PROJECTS20222024}
          component={Projects202224}
        />
        <Route
          exact
          path={ROUTES.PROJECTS_FINANCIALMONTHLYSUPPORT}
          component={FinancialMonthlySupport}
        />
        <Route
          exact
          path={ROUTES.PROJECTS_MONTHLYRATIONSUPPORT}
          component={MonthlyRationSupport}
        />
        <Route
          exact
          path={ROUTES.PROJECTS_SMALLBUSINESSPROGRAM}
          component={SmallBusinessProgram}
        />
        <Route
          exact
          path={ROUTES.PROJECTS_TECHNICALCENTERFOREMPOWERINGWOMEN}
          component={TechnicalCenterForEmpoweringWomen}
        />
        <Route
          exact
          path={ROUTES.PROJECTS_EDUCATIONPROGRAM}
          component={EducationProgram}
        />
        <Route
          exact
          path={ROUTES.PROJECTS_MEDICALPROGRAM}
          component={MedicalProgram}
        />
        <Route
          exact
          path={ROUTES.PROJECTS_CLEANWATERPROJECTS}
          component={CleanWaterProjects}
        />

        <Route
          exact
          path={ROUTES.WOMENS_VOCATIONAL_TRAINING}
          component={WomensVocationalTraining}
        />
        <Route
          exact
          path={ROUTES.HEATSTROKE_RELIEF_CAMPS}
          component={HeatstrokeReliefCamps}
        />
        <Route
          exact
          path={ROUTES.ORPHAN_MARRIAGE_ASSISTANCE}
          component={OrphanMarriageAssistance}
        />
      </Switch>
    </Router>
  );
}

export default App;
